$(document).ready(function() {
  if (window.location.pathname === '/') {
    // Zero based list of quotes to show on the front page, quotes can be found in data/quotes.json
    var quotesToShow = [0, 2, 4];

    getQuotes(function(quotes) {
      $(quotes).each(function(key, item) {
        if (quotesToShow.indexOf(key) !== -1) {
          addSnippet(item);
        }
      });
      var $items = $('.carousel > .item');
      var current = 0;
      $($items[current]).addClass('current');
      window.setInterval(function() {
        var now = current;
        current = current < $items.length - 1 ? current + 1 : 0;
        $($items[now]).toggle();
        $($items[current]).toggle();
      }, 5000);
    });

    function addSnippet(item) {
      $('.carousel').append(
        '<figure class="item"><blockquote>' +
          item.snippet +
          '</blockquote><span class="mdl-typography--subhead">— ' +
          item.by +
          '</span></figure>'
      );
    }
  }

  if (
    window.location.pathname === '/contact' ||
    window.location.pathname === '/contact/'
  ) {
    window.recaptchaValid = function() {
      $('.g-recaptcha div.is-invalid').removeClass('is-invalid');
    };

    $('#submit').on('click', function() {
      var submit = true;

      $('input, textarea').each(function() {
        if ($(this).val().length <= 0) {
          $(this)
            .parent()
            .addClass('is-invalid');
          submit = false;
        }
      });

      function error() {
        $('.message-container__text')
          .html('Unable to send at this time')
          .toggleClass(
            'mdl-color-text--light-green-700 mdl-color-text--red-800'
          );
        $('.message-container').css('display', 'block');
      }

      if (submit) {
        $('#submit').attr('disabled', 'disabled');
        $.ajax({
          type: 'POST',
          url: 'https://bbdjr4vux0.execute-api.us-west-2.amazonaws.com/prod',
          contentType: 'application/json',
          data: JSON.stringify({
            name: $('#name').val(),
            email: $('#email').val(),
            message: $('#message').val(),
            to: 'Lukava',
            captcha: $('#g-recaptcha-response').val()
          })
        })
          .done(function(data) {
            if (data !== 'success') {
              error();
            }
            $('.message-container').css('display', 'block');
          })
          .fail(function(jqXHR) {
            console.log(JSON.parse(jqXHR.responseText));
            error();
          });
      }
    });

    function init_map() {
      var a = {
        zoom: 13,
        center: new google.maps.LatLng(39.662891099999996, -104.86221588718536),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        disableDefaultUI: !0,
        scrollwheel: !1,
        draggable: !1
      };
      (map = new google.maps.Map(document.getElementById('gmap_canvas'), a)),
        (marker = new google.maps.Marker({
          map: map,
          position: new google.maps.LatLng(
            39.662891099999996,
            -104.86221588718536
          )
        })),
        (infowindow = new google.maps.InfoWindow({
          content:
            '<strong>Lukava, LLC</strong><br>10800 E Bethany Drive, Suite 225, Aurora, CO 80014<br>'
        })),
        google.maps.event.addListener(marker, 'click', function() {
          infowindow.open(map, marker);
        }),
        infowindow.open(map, marker);
    }
    var map;
    google.maps.event.addDomListener(window, 'load', init_map),
      (window.onresize = function() {
        (lastCenter = map.getCenter()),
          google.maps.event.trigger(gmap_canvas, 'resize'),
          map.setCenter(lastCenter);
      });
  }

  if (
    window.location.pathname === '/testimonials' ||
    window.location.pathname === '/testimonials/'
  ) {
    var genQuote = function(item) {
      $('.lukava-testimonials-section__container').append(
        '<figure class="mdl-shadow--2dp"><blockquote>' +
          item.quote +
          '</blockquote><span class="mdl-typography--subhead">— ' +
          item.by +
          '</span></figure>'
      );
    };

    getQuotes(function(quotes) {
      $(quotes).each(function(key, item) {
        genQuote(item);
      });
      var $items = $('.carousel > .item');
      var current = 0;
      $($items[current]).addClass('current');
      window.setInterval(function() {
        var now = current;
        current = current < $items.length - 1 ? current + 1 : 0;
        $($items[now]).toggle();
        $($items[current]).toggle();
      }, 5000);
    });
  }

  function getQuotes(callback) {
    if (sessionStorage.getItem('quotes')) {
      callback(JSON.parse(sessionStorage.getItem('quotes')));
      return;
    }
    $.getJSON('/data/quotes.json', function(data) {
      sessionStorage.setItem('quotes', JSON.stringify(data));
      callback(data);
    });
    return;
  }
});
